import * as React from 'react';

function SvgCloseMinus(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.302 14.364c.386 0 .698.335.698.75 0 .414-.312.75-.698.75H5.698c-.386 0-.698-.336-.698-.75 0-.415.312-.75.698-.75h18.604z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgCloseMinus;
